/**
 * @typedef {Object} PostRepositoryResult
 * @property {Post[]} posts
 * @property {string|null} lastPost
 * @property {boolean} hasMore
 */

export class PostRepository {
  /**
   * @param {Object} params
   * @param {number} [params.limit]
   * @param {string|null} [params.startAfter]
   * @returns {Promise<PostRepositoryResult>}
   */
  async getPosts({ limit, startAfter }) {
    throw new Error('Method not implemented');
  }

  /**
   * @param {Object} params
   * @param {Object} params.center - Coordonnées du centre {latitude, longitude}
   * @param {number} params.radiusInKm - Rayon de recherche en kilomètres
   * @param {number} [params.limit] - Nombre maximum de résultats
   * @param {string} [params.excludeUserId] - ID de l'utilisateur à exclure
   * @param {boolean} [params.refresh] - Force le rafraîchissement des données
   * @returns {Promise<PostRepositoryResult>}
   */
  async getNearbyPosts({ center, radiusInKm, limit, excludeUserId, refresh }) {
    throw new Error('Method not implemented');
  }

  /**
   * @param {Object} postData
   * @param {string} userId
   * @param {string} userName
   * @returns {Promise<string>} Returns the created post ID
   */
  async createPost(postData, userId, userName) {
    throw new Error('Method not implemented');
  }

  /**
   * @param {string} postId
   * @param {string} userId
   * @returns {Promise<boolean>}
   */
  async joinActivity(postId, userId) {
    throw new Error('Method not implemented');
  }

  /**
   * @param {string} postId
   * @param {string} userId
   * @returns {Promise<boolean>}
   */
  async leaveActivity(postId, userId) {
    throw new Error('Method not implemented');
  }

  /**
   * @param {string} postId
   * @param {string} userId
   * @returns {Promise<boolean>}
   */
  async savePost(postId, userId) {
    throw new Error('Method not implemented');
  }

  /**
   * @param {string} postId
   * @param {string} userId
   * @returns {Promise<boolean>}
   */
  async unsavePost(postId, userId) {
    throw new Error('Method not implemented');
  }

  /**
   * @param {string} postId
   * @returns {Promise<boolean>}
   */
  async incrementShares(postId) {
    throw new Error('Method not implemented');
  }

  /**
   * @param {string} postId
   * @returns {Promise<Post>}
   */
  async getPostById(postId) {
    throw new Error('Method not implemented');
  }

  /**
   * @param {string} postId
   * @param {string} userId - L'ID de l'utilisateur qui tente de supprimer le post
   * @returns {Promise<boolean>} - true si supprimé avec succès
   * @throws {Error} Si l'utilisateur n'est pas autorisé ou si la suppression échoue
   */
  async deletePost(postId, userId) {
    throw new Error('Method not implemented');
  }

  /**
   * S'abonne aux mises à jour en temps réel d'un post spécifique
   * @param {Object} params - Paramètres de l'abonnement
   * @param {string} params.postId - ID du post à écouter
   * @param {Function} params.onUpdate - Callback appelé quand le post est mis à jour
   * @param {Function} params.onError - Callback appelé en cas d'erreur
   * @returns {Promise<Function>} - Fonction pour désabonner
   */
  async subscribeToPost({ postId, onUpdate, onError }) {
    throw new Error('Method not implemented');
  }

  /**
   * S'abonne aux mises à jour en temps réel des posts à proximité
   * @param {Object} params - Paramètres de l'abonnement
   * @param {Object} params.center - Coordonnées du centre {latitude, longitude}
   * @param {number} params.radiusInKm - Rayon de recherche en kilomètres
   * @param {number} params.limit - Nombre maximum de résultats
   * @param {string} params.excludeUserId - ID de l'utilisateur à exclure
   * @param {Function} params.onUpdate - Callback appelé quand les posts sont mis à jour
   * @param {Function} params.onError - Callback appelé en cas d'erreur
   * @returns {Promise<Function>} - Fonction pour désabonner
   */
  async subscribeToNearbyPosts({ center, radiusInKm, limit, excludeUserId, onUpdate, onError }) {
    throw new Error('Method not implemented');
  }
} 